import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { CardPay, FeeLine, SaveCardBox } from "@/components/CardPay";

export default function PayLinkPage() {
  const { linkId } = useParams();
  const [params] = useSearchParams();
  const t = params.get("t") || "";
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState("");
  const [paying, setPaying] = useState(false);
  const [save, setSave] = useState(true);
  const [done, setDone] = useState(false);
  useEffect(() => { api.get(`/paylink/${linkId}`, { params: { t } }).then((r) => setInfo(r.data)).catch((e) => setErr(e?.response?.data?.detail || "Link not found")); }, [linkId, t]);
  const pay = async (sourceId, verificationToken) => {
    setPaying(true);
    try {
      await api.post(`/paylink/${linkId}/pay`, { t, source_id: sourceId, verification_token: verificationToken, save_card: save });
      setDone(true);
    } catch (e) { toast.error(e?.response?.data?.detail || "Payment failed"); } finally { setPaying(false); }
  };
  if (err) return <div className="min-h-screen bg-[#050505] text-gray-300 flex items-center justify-center" data-testid="paylink-error">{err}</div>;
  if (!info) return <div className="min-h-screen bg-[#050505] flex items-center justify-center"><Loader2 className="w-6 h-6 animate-spin text-sky-400" /></div>;
  const paid = done || info.status === "paid";
  return (
    <div className="min-h-screen bg-[#050505] text-white flex items-center justify-center p-6" data-testid="paylink-page">
      <div className="w-full max-w-md rounded-3xl border border-white/10 bg-white/[0.02] p-8 space-y-5">
        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-sky-400">Reflections Auto Detailing</p>
          <h1 className="font-['Outfit'] text-3xl mt-2" data-testid="paylink-title">{info.description}</h1>
          {info.customer_name && <p className="text-sm text-gray-400 mt-1">For {info.customer_name}</p>}
        </div>
        <div className="space-y-1 border-t border-white/5 pt-4">
          <div className="flex justify-between text-sm text-gray-300"><span>Amount</span><span>${info.amount.toFixed(2)}</span></div>
          <FeeLine fee={info.card_fee} pct={info.card_fee_pct} />
          <div className="flex justify-between text-lg font-semibold pt-2" data-testid="paylink-total"><span>Total</span><span>${info.total.toFixed(2)}</span></div>
        </div>
        {paid ? (
          <p className="flex items-center gap-2 text-emerald-300" data-testid="paylink-paid"><CheckCircle2 className="w-5 h-5" /> Paid — thank you!</p>
        ) : info.status !== "unpaid" ? <p className="text-amber-300 text-sm">This link is no longer active.</p> : (
          <>
            <CardPay amount={info.total} onToken={pay} busy={paying} buyerName={info.customer_name} label={`Pay $${info.total.toFixed(2)}`} />
            <SaveCardBox checked={save} onChange={setSave} />
          </>
        )}
      </div>
    </div>
  );
}
